import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';

export type GetCancelWinbackResponse = {
  promo_code: string | null;
  promo_data: PromoData | null;
};

export enum PromoType {
  FLAT_DISCOUNT = 0,
  PERCENT_DISCOUNT = 1,
}

export interface PromoData {
  promos: Promo[];
}

export interface Promo {
  value: string;
  effect: string;
  type: PromoType;
}

export async function getCancelWinback() {
  return send<GetCancelWinbackResponse>({
    path: '/api/get_cancel_winback/',
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
